export const ILLUSTO_CLIP_STATUS = {
  PENDING: "pending",
  COMPLETE: "complete",
  FAILED: "failed",
};

// currently this is specific for tennis while creating studio video templates
export const STUDIO_TEMPLATE_MATCH_TYPES = [
  {
    label: "None",
    value: null,
    datafeedValue: null,
  },
  {
    label: "Singles",
    value: "singles",
    datafeedValue: "S",
  },
  {
    label: "Doubles",
    value: "doubles",
    datafeedValue: "D",
  },
];

export const STUDIO_TEMPLATE_FILTER_DROPDOWN_TYPES = [
  {
    label: "General",
    value: "general",
  },
  {
    label: "Asset Type",
    value: "asset_type",
  },
  {
    label: "Match Type",
    value: "match_type",
  },
];

export const STUDIO_TEMPLATE_SEGMENT_TYPE_OPTIONS = {
  scorebug: [
    {
      label: "Start",
      value: "start",
    },
    {
      label: "End",
      value: "end",
    },
  ],
};
